(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ca-sod-005-nav-desktop"] && !Shopify.designMode) return;
  try {
    (() => {
    const caSod005NavRoot = document.querySelector('[data-ca-sod-005-nav-desktop]')
    if (!caSod005NavRoot) return

    const caSod005NavSearch = caSod005NavRoot.querySelector('[data-ca-sod-005-nav-search]')
    const caSod005NavSearchToggle = caSod005NavRoot.querySelector('[data-ca-sod-005-nav-search-toggle]')
    const caSod005NavSearchInput = caSod005NavRoot.querySelector('[data-ca-sod-005-nav-search-input]')
    const caSod005NavSearchClose = caSod005NavRoot.querySelector('[data-ca-sod-005-nav-search-close]')
    const caSod005NavUtility = caSod005NavRoot.querySelector('.ca-sod-005-nav-utility')
    const caSod005NavKlevuPanelSelector = '.kuQuickSearchAutoCompleteLayout.klevuTarget.klevu-fluid > div'
    // Klevu renders its quick-search panel outside the nav markup, so any interaction
    // with it has to be treated as "still inside the search UI".
    const caSod005NavKlevuRootSelector = '.kuQuickSearchAutoCompleteLayout, .klevuTarget, .klevuQuickSearchingArea, #klevuSearchingArea, .kuSearchResultsWrapper'
    const caSod005NavIsInsideKlevu = (caSod005NavNode) => {
      if (!caSod005NavNode) return false
      const caSod005NavElement = caSod005NavNode.nodeType === 1 ? caSod005NavNode : caSod005NavNode.parentElement
      return Boolean(caSod005NavElement && caSod005NavElement.closest(caSod005NavKlevuRootSelector))
    }
    let caSod005NavCloseSearch = () => {}

    if (caSod005NavSearch && caSod005NavSearchToggle && caSod005NavSearchInput) {
      const caSod005NavGetKlevuPanels = () => [...document.querySelectorAll(caSod005NavKlevuPanelSelector)]
      const caSod005NavUpdateKlevuPanelTop = () => {
        if (!caSod005NavUtility) return
        const caSod005NavUtilityBottom = caSod005NavUtility.getBoundingClientRect().bottom
        document.body.style.setProperty('--ca-sod-005-nav-klevu-panel-top', `${Math.max(0, caSod005NavUtilityBottom)}px`)
      }
      const caSod005NavClearKlevuPanelTop = () => {
        document.body.style.removeProperty('--ca-sod-005-nav-klevu-panel-top')
      }
      const caSod005NavHandleKlevuPanelViewportChange = () => {
        if (caSod005NavRoot.classList.contains('ca-sod-005-nav-desktop--search-active')) {
          caSod005NavUpdateKlevuPanelTop()
        }
      }

      const caSod005NavUpdateSearchSuggestionsState = () => {
        caSod005NavHandleKlevuPanelViewportChange()

        const caSod005NavHasVisibleSuggestions = caSod005NavGetKlevuPanels().some((caSod005NavKlevuPanel) => {
          const caSod005NavKlevuPanelStyle = window.getComputedStyle(caSod005NavKlevuPanel)
          const caSod005NavKlevuPanelRect = caSod005NavKlevuPanel.getBoundingClientRect()

          return caSod005NavSearch.classList.contains('ca-sod-005-nav-search--open')
            && caSod005NavSearchInput.value.trim() !== ''
            && caSod005NavKlevuPanel.getAttribute('data-ca-sod-005-nav-hidden') !== 'true'
            && caSod005NavKlevuPanelStyle.display !== 'none'
            && caSod005NavKlevuPanelStyle.visibility !== 'hidden'
            && caSod005NavKlevuPanelRect.width > 0
            && caSod005NavKlevuPanelRect.height > 0
        })

        caSod005NavRoot.classList.toggle('ca-sod-005-nav-desktop--search-suggestions-active', caSod005NavHasVisibleSuggestions)
      }

      const caSod005NavShowKlevuSearchSuggestions = () => {
        caSod005NavUpdateKlevuPanelTop()

        if (caSod005NavSearchInput.value.trim() === '') {
          caSod005NavRoot.classList.remove('ca-sod-005-nav-desktop--search-suggestions-active')
          return
        }

        caSod005NavGetKlevuPanels().forEach((caSod005NavKlevuPanel) => {
          caSod005NavKlevuPanel.removeAttribute('data-ca-sod-005-nav-hidden')
          caSod005NavKlevuPanel.style.display = ''
        })
        window.requestAnimationFrame(caSod005NavUpdateSearchSuggestionsState)
      }

      const caSod005NavHideKlevuSearchSuggestions = () => {
        caSod005NavGetKlevuPanels().forEach((caSod005NavKlevuPanel) => {
          caSod005NavKlevuPanel.setAttribute('data-ca-sod-005-nav-hidden', 'true')
          caSod005NavKlevuPanel.style.display = 'none'
        })
        caSod005NavClearKlevuPanelTop()
        caSod005NavRoot.classList.remove('ca-sod-005-nav-desktop--search-suggestions-active')
      }

      const caSod005NavOpenSearch = () => {
        caSod005NavSearch.classList.add('ca-sod-005-nav-search--open')
        caSod005NavRoot.classList.add('ca-sod-005-nav-desktop--search-active')
        caSod005NavSearchToggle.setAttribute('aria-expanded', 'true')
        caSod005NavSearchInput.removeAttribute('tabindex')
        if (caSod005NavSearchClose) caSod005NavSearchClose.removeAttribute('tabindex')
        caSod005NavShowKlevuSearchSuggestions()
        window.requestAnimationFrame(() => caSod005NavSearchInput.focus({ preventScroll: true }))
      }

      caSod005NavCloseSearch = () => {
        caSod005NavSearch.classList.remove('ca-sod-005-nav-search--open')
        caSod005NavRoot.classList.remove('ca-sod-005-nav-desktop--search-active')
        caSod005NavHideKlevuSearchSuggestions()
        caSod005NavSearchToggle.setAttribute('aria-expanded', 'false')
        caSod005NavSearchInput.setAttribute('tabindex', '-1')
        if (caSod005NavSearchClose) caSod005NavSearchClose.setAttribute('tabindex', '-1')
        const caSod005NavActiveElement = document.activeElement
        if (caSod005NavActiveElement && caSod005NavSearch.contains(caSod005NavActiveElement) && typeof caSod005NavActiveElement.blur === 'function') {
          caSod005NavActiveElement.blur()
        }
      }

      caSod005NavSearchToggle.addEventListener('click', caSod005NavOpenSearch)
      caSod005NavSearchInput.addEventListener('focus', caSod005NavOpenSearch)
      caSod005NavSearchInput.addEventListener('input', () => {
        caSod005NavShowKlevuSearchSuggestions()
        window.setTimeout(caSod005NavUpdateSearchSuggestionsState, 150)
      })
      window.addEventListener('scroll', caSod005NavHandleKlevuPanelViewportChange, { passive: true })
      window.addEventListener('resize', caSod005NavHandleKlevuPanelViewportChange)

      // Pointer interactions inside the Klevu panel blur the input before the click
      // resolves. Without this flag the focusout handler below would hide the panel
      // mid-click and the result link would never be followed.
      let caSod005NavKlevuPointerActive = false

      document.addEventListener('pointerdown', (caSod005NavEvent) => {
        if (caSod005NavIsInsideKlevu(caSod005NavEvent.target)) {
          caSod005NavKlevuPointerActive = true
          return
        }

        caSod005NavKlevuPointerActive = false

        if (!caSod005NavSearch.classList.contains('ca-sod-005-nav-search--open')) return
        if (caSod005NavSearch.contains(caSod005NavEvent.target)) return
        caSod005NavCloseSearch()
      }, true)

      const caSod005NavReleaseKlevuPointer = () => {
        window.setTimeout(() => {
          caSod005NavKlevuPointerActive = false
        }, 0)
      }

      document.addEventListener('pointerup', caSod005NavReleaseKlevuPointer, true)
      document.addEventListener('pointercancel', caSod005NavReleaseKlevuPointer, true)

      caSod005NavSearch.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (caSod005NavKlevuPointerActive) return
          if (caSod005NavIsInsideKlevu(document.activeElement)) return
          if (!caSod005NavSearch.contains(document.activeElement)) caSod005NavCloseSearch()
        }, 0)
      })

      if (caSod005NavSearchClose) {
        caSod005NavSearchClose.addEventListener('click', caSod005NavCloseSearch)
      }

      if ('MutationObserver' in window) {
        const caSod005NavSearchSuggestionsObserver = new MutationObserver(() => {
          window.requestAnimationFrame(caSod005NavUpdateSearchSuggestionsState)
        })

        caSod005NavSearchSuggestionsObserver.observe(document.body, {
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'data-ca-sod-005-nav-hidden'],
          childList: true,
          subtree: true
        })
      }
    }

    const caSod005NavCartLinks = [...caSod005NavRoot.querySelectorAll('[cart-icon]')]
    const caSod005NavCartIndicators = [...caSod005NavRoot.querySelectorAll('[data-ca-sod-005-nav-cart-indicator]')]

    const caSod005NavCartCountFromCart = (caSod005NavCart) => {
      if (!caSod005NavCart) return null
      const caSod005NavItemCount = Number(caSod005NavCart.item_count)
      if (Number.isFinite(caSod005NavItemCount)) return caSod005NavItemCount
      if (!Array.isArray(caSod005NavCart.items)) return null
      return caSod005NavCart.items.reduce((caSod005NavTotal, caSod005NavItem) => {
        const caSod005NavQuantity = Number(caSod005NavItem?.quantity)
        return caSod005NavTotal + (Number.isFinite(caSod005NavQuantity) ? caSod005NavQuantity : 0)
      }, 0)
    }

    const caSod005NavSetCartIndicators = (caSod005NavCount) => {
      const caSod005NavSafeCount = Math.max(0, Number(caSod005NavCount) || 0)

      caSod005NavCartIndicators.forEach((caSod005NavIndicator) => {
        caSod005NavIndicator.hidden = caSod005NavSafeCount === 0
      })

      caSod005NavCartLinks.forEach((caSod005NavCartLink) => {
        const caSod005NavBaseLabel = caSod005NavCartLink.getAttribute('data-ca-sod-005-nav-cart-label') || 'Cart'
        const caSod005NavItemLabel = caSod005NavSafeCount === 1 ? 'item' : 'items'
        caSod005NavCartLink.setAttribute('data-ca-sod-005-nav-cart-count', String(caSod005NavSafeCount))
        caSod005NavCartLink.setAttribute(
          'aria-label',
          caSod005NavSafeCount > 0 ? `${caSod005NavBaseLabel}, ${caSod005NavSafeCount} ${caSod005NavItemLabel}` : caSod005NavBaseLabel
        )
      })
    }

    const caSod005NavFetchCartCount = async () => {
      try {
        const caSod005NavResponse = await fetch('/cart.js', { credentials: 'same-origin' })
        if (!caSod005NavResponse.ok) return
        const caSod005NavCart = await caSod005NavResponse.json()
        const caSod005NavCount = caSod005NavCartCountFromCart(caSod005NavCart)
        if (caSod005NavCount !== null) caSod005NavSetCartIndicators(caSod005NavCount)
      } catch (caSod005NavError) {
        console.error(caSod005NavError)
      }
    }

    if (caSod005NavCartLinks.length > 0 && caSod005NavCartIndicators.length > 0) {
      const caSod005NavInitialCount = Number(caSod005NavCartLinks[0].getAttribute('data-ca-sod-005-nav-cart-count') || '0')
      caSod005NavSetCartIndicators(caSod005NavInitialCount)

      window.addEventListener('cart:updated', (caSod005NavEvent) => {
        const caSod005NavCount = caSod005NavCartCountFromCart(caSod005NavEvent.detail)
        if (caSod005NavCount !== null) caSod005NavSetCartIndicators(caSod005NavCount)
      })

      document.addEventListener('addToCart', (caSod005NavEvent) => {
        const caSod005NavCount = Number(caSod005NavEvent.detail?.cartQuantity)
        if (Number.isFinite(caSod005NavCount)) {
          caSod005NavSetCartIndicators(caSod005NavCount)
          return
        }
        caSod005NavFetchCartCount()
      })

      document.addEventListener('resetCart', () => caSod005NavSetCartIndicators(0))
    }

    const caSod005NavDetailsList = [...caSod005NavRoot.querySelectorAll('[data-ca-sod-005-nav-details]')]
    let caSod005NavCloseTimer = null

    const caSod005NavCanOpenDetails = (caSod005NavDetails) => {
      if (!caSod005NavDetails) return false
      if (caSod005NavDetails.getAttribute('data-ca-sod-005-nav-availability-gated') !== 'true') return true
      return caSod005NavDetails.getAttribute('data-ca-sod-005-nav-availability-enabled') === 'true'
    }

    const caSod005NavCloseAllDetails = () => {
      caSod005NavDetailsList.forEach((caSod005NavDetails) => caSod005NavDetails.removeAttribute('open'))
    }

    caSod005NavDetailsList.forEach((caSod005NavDetails) => {
      const caSod005NavItem = caSod005NavDetails.closest('.ca-sod-005-nav-primary__item')
      const caSod005NavSummary = caSod005NavDetails.querySelector('summary')
      const caSod005NavHoverRoot = caSod005NavItem || caSod005NavDetails

      caSod005NavHoverRoot.addEventListener('mouseenter', () => {
        window.clearTimeout(caSod005NavCloseTimer)
        if (!caSod005NavCanOpenDetails(caSod005NavDetails)) {
          caSod005NavCloseAllDetails()
          return
        }
        caSod005NavDetailsList.forEach((caSod005NavOtherDetails) => {
          if (caSod005NavOtherDetails !== caSod005NavDetails) caSod005NavOtherDetails.removeAttribute('open')
        })
        caSod005NavDetails.setAttribute('open', '')
      })

      caSod005NavHoverRoot.addEventListener('mouseleave', () => {
        caSod005NavCloseTimer = window.setTimeout(() => caSod005NavDetails.removeAttribute('open'), 150)
      })

      caSod005NavHoverRoot.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!caSod005NavHoverRoot.contains(document.activeElement)) caSod005NavDetails.removeAttribute('open')
        }, 0)
      })

      if (caSod005NavSummary) {
        caSod005NavSummary.addEventListener('click', (caSod005NavEvent) => {
          caSod005NavEvent.preventDefault()
          if (!caSod005NavCanOpenDetails(caSod005NavDetails)) {
            caSod005NavCloseAllDetails()
            return
          }
          const caSod005NavIsOpen = caSod005NavDetails.hasAttribute('open')
          caSod005NavCloseAllDetails()
          if (!caSod005NavIsOpen) caSod005NavDetails.setAttribute('open', '')
        })
      }
    })

    document.addEventListener('keydown', (caSod005NavEvent) => {
      if (caSod005NavEvent.key !== 'Escape') return
      if (caSod005NavSearch && caSod005NavSearch.classList.contains('ca-sod-005-nav-search--open')) caSod005NavCloseSearch()
      caSod005NavCloseAllDetails()
    })

    document.addEventListener('click', (caSod005NavEvent) => {
      if (caSod005NavRoot.contains(caSod005NavEvent.target)) return
      caSod005NavCloseAllDetails()
    })
  })()
  } catch(e) { console.error(e); }
})();

})();
